import { SchoolYear } from '@pelckmans/business-components/context/SchoolYearContext';

export function toId(schoolYear: SchoolYear) {
  return `${schoolYear.from.getFullYear()}-${schoolYear.to.getFullYear()}`;
}
